import styled from "styled-components";

export const BannerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3vh;
  justify-content: center;
  align-items: center;
  max-width: 1334px;
  justify-self: center;
  
  @media (max-width: 986px) {
    padding: 2%;
    grid-template-columns: 1fr;
    gap: 2vh;
  }
`;

export const BannerItem = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1920px;
`;

export const BannerImage = styled.img`
  width: 100%;
  border-radius: 6px;
  height: 200px;
`;